import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-scan-cv',
  templateUrl: './scan-cv.component.html',
  styleUrls: ['./scan-cv.component.css'],
})
export class ScanCvComponent {
  services = [
    {
      color: 'blue',
      img: '../../../assets/icon/paper.png',
      title: 'Format',
      description: [
        'File format and size',
        'Resume length',
        'Long bullet points with suggestions on how to shorten',
      ],
    },
    {
      color: 'pink',
      img: '../../../assets/icon/img.png',

      title: 'Resume sections',
      description: [
        'Contact information',
        'Essential sections',
        'Personality showcase with tips on how to improve',
      ],
    },
    {
      color: 'blue',
      img: '../../../assets/icon/pen.png',

      title: 'Resume sections',
      description: [
        'Contact information',
        'Essential sections',
        'Personality showcase with tips on how to improve',
      ],
    },
    {
      color: 'pink',
      img: '../../../assets/icon/lamp.png',

      title: 'Resume sections',
      description: ['Contact information', 'Essential sections'],
    },
    {
      color: 'blue',
      img: '../../../assets/icon/a.png',

      title: 'Style',
      description: [
        'Resume design',
        'Email address',
        'Usage of active voice',
        'Usage of buzzwords and cliches',
      ],
    },
  ];
  steps: MenuItem[] = [];
  activeIndex: any = 0;
  text: string | undefined;
  test: string = '';
  cv: any = '';

  cvResultData: any;
  constructor(
    private translate: TranslateService,
    private router: Router
  ) {
    this.getTranslate();
    this.translate.onLangChange.subscribe(() => {
      this.getTranslate();
    });
  }
  getTranslate() {
    this.translate
      .get(['Upload Resume', 'Result'])
      .subscribe((translations) => {
        this.steps = [
          { label: translations['Upload Resume'] },

          { label: translations['Result'] },
        ];
      });
  }
  onCVDrop(event: any) {
    event.preventDefault();

    this.cv = event.dataTransfer.files[0];

    if (this.cv) {
      this.nextStep();
    }
  }

  onCVSelected(event: any) {
    this.cv = event.target.files[0];
    if (this.cv) {
      this.nextStep();
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  nextStep() {
    if (this.activeIndex === 0 && this.cv) {
      this.navigate(this.cv);
    } else {
      this.activeIndex = +1;
    }
  }

  navigate(data: any) {
    this.router.navigate(['/scan-cv-result'], {
      state: { data },
    });
  }
}
